import { render, staticRenderFns } from "./MailTemplateEditor.vue?vue&type=template&id=2d3a3886&scoped=true"
import script from "./MailTemplateEditor.vue?vue&type=script&lang=js"
export * from "./MailTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateEditor.vue?vue&type=style&index=0&id=2d3a3886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a3886",
  null
  
)

export default component.exports